var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 8V12L13.7321 13M2.25939 14.2727C2.08971 13.5426 2 12.7818 2 12C2 11.2182 2.08971 10.4574 2.25939 9.72727M10.1818 2.16489C10.7714 2.05659 11.3791 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C11.3791 22 10.7714 21.9434 10.1818 21.8351M7 3.33782C5.63602 4.12684 4.47571 5.22877 3.61721 6.54545M3.61721 17.4545C4.47571 18.7712 5.63602 19.8732 7 20.6622",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeLoading);
export default __webpack_public_path__ + "static/media/time-loading.5ab21b5b2840d53ba24411c3f7144a1a.svg";
export { ForwardRef as ReactComponent };